import { Form, withFormik } from "formik";
import { useTranslation, withTranslation } from "react-i18next";
import { validateSomething, validateString50 } from "../../Form/Validations";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import DropdownPrime from "../../PrimeComponents/DropdownPrime";
import CalendarPrime from "../../PrimeComponents/CalendarPrime";
import { Checkbox } from "primereact/checkbox";
import InputTextPrime from "../../PrimeComponents/InputTextPrime";

dayjs.extend(utc);
dayjs.extend(tz);

const IrrimaxForm = ({ dialogState, setDialogState, handleSubmit, errors, values, setFieldValue, touched, setForceLoading }) => {
    const { t, i18n } = useTranslation();

    const onChangeLogger = ({value}) => {
        if (value){
            const selectedLogger = value;
            setDialogState((state) => {
                return {
                    ...state,
                    selectedLogger,
                };
            });
            setFieldValue("logger_id", value.id);
            setFieldValue("nombre_sector", selectedLogger?.name);
        }
    };

    const timezones = Intl.supportedValuesOf("timeZone");
    const now = new Date();
    const minDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 3,
        new Date().getDate()
    );

    return (
        <div id="extFormContent2">
            <Form id="irrimax_form" onSubmit={handleSubmit}>
                {dialogState?.unsupportedLoggers?.length > 0 && (
                    <>
                        <div className="col-12 col-md-12">
                            <label className="boldie text-left">
                                Unsupported Loggers
                            </label>
                        </div>
                        <div className="mb-2 col-12 col-md-12 d-block">
                            <ul>
                                {dialogState.unsupportedLoggers.map((logger, id) => {
                                    return <li key={id}> {logger} </li>;
                                })}
                            </ul>
                        </div>
                    </>
                )}
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorIrrimax">
                        Logger
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    {dialogState?.supportedLoggers && (
                        <DropdownPrime
                            id='logger_id'
                            name="logger_id"
                            filter={false}
                            value={dialogState.selectedLogger}
                            onChange={onChangeLogger}
                            options={dialogState?.supportedLoggers} optionLabel="name"
                            placeholder="Logger"
                            showClear={false}
                        />
                    )}
                </div>
                {
                    !dialogState.selectedLogger && errors.logger_id &&
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">Logger: {t(errors.logger_id)}</div>
            </div>
                }
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie" name="sectorIrrimax">
                        {t("external.sector-name")}
                    </label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <InputTextPrime
                        name="nombre_sector"
                        value={values.nombre_sector}
                        placeholder={t("external.sector-name")}
                        onChange={e => setFieldValue("nombre_sector", e.target.value)}
                    />
                </div>
                {
                    errors.nombre_sector &&
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{t("external.sector-name")}: {t(errors.nombre_sector)}</div>
            </div>
                }
                <div className="row linea-formulario" />
                <div className="col-12 col-md-12">
                    <label className="boldie">{t("node.ultimoDato")}</label>
                </div>
                <div className="mb-2 col-12 col-md-12 d-block">
                    <CalendarPrime
                        t={t}
                        minDate={minDate}
                        maxDate={now}
                        value={values?.last_data}  onChange={(e) => setFieldValue("last_data", e.value)}
                        locale={i18n.language}
                        placeholder={t("forms.formatoFecha")}
                        style={{width:"100%"}}
                    />
                </div>
                {
                    touched.last_data && errors.last_data &&
            <div className="mb-2 col-12 d-block">
                <div className="alert alert-warning m-0" role="alert">{t("node.ultimoDato")}: {t(errors.last_data)}</div>
            </div>
                }
                <div className="row linea-formulario" />
                <div className="mb-2 col-12 col-md-12">
                    <Checkbox onChange={(e) => {
                        setFieldValue("timezone", null);
                        setDialogState((state) => ({
                            ...state,
                            advancedOptions: e.checked,
                        }));
                    }} checked={dialogState.advancedOptions}
                    />
                    <span className="ml-1 mini-boldie-text">{t("external.advancedOptions")}</span>
                </div>
                {dialogState?.advancedOptions && (
                    <>
                        <div className="col-12 col-md-12">
                            <label name="timezone" className="boldie">
                                {t("external.timezoneOfData")}
                            </label>
                        </div>
                        <div className="mb-2 col-12 col-md-12 d-block">
                            <div className="">
                                <DropdownPrime
                                    id='timezone'
                                    name="timezone"
                                    filter={false}
                                    value={values.timezone}
                                    onChange={(e) => setFieldValue("timezone", e.value)}
                                    options={timezones}
                                    placeholder={t("farms.farmTable.timeZone")}
                                    showClear={false}
                                />
                            </div>
                        </div>
                        {
                            touched.timezone && errors.timezone &&
              <div className="mb-2 col-12 d-block">
                  <div className="alert alert-warning m-0" role="alert">{t("farms.farmTable.timeZone")}: {t(errors.timezone)}</div>
              </div>
                        }
                    </>
                )}
                <div className="row linea-formulario" />
                {dialogState?.selectedLogger && (
                    <>
                        <div className="col-12 col-md-12">
                            <label className="boldie text-left">
                                {t("external.availableSensors")}
                            </label>
                        </div>
                        <div className="mb-2 col-12 col-md-12 d-block">
                            <ul>
                                {!dialogState.selectedLogger.sensors.length && (
                                    <li>No sensors</li>
                                )}
                                {dialogState.selectedLogger.sensors.map((sensor, id) => {
                                    let text = sensor.tipo;
                                    if (sensor.depths?.length > 0) {
                                        const depthsText = sensor.depths.join(", ");
                                        text += ` (${depthsText})`;
                                    }
                                    return <li key={id}> {text} </li>;
                                })}
                            </ul>
                        </div>
                    </>
                )}
            </Form>
        </div>
    );
};

const IrrimaxFormikForm = withFormik({
    mapPropsToValues: () => {
        return {
            logger_id: null,
            nombre_sector: null,
            last_data: null,
            timezone: null
        };
    },
    validate: (values, props) => {
        const errors = {};
        if (values) {
            for (const field of Object.keys(values)) {
                if (["logger_id", "last_data"].includes(field)) {
                    const er = validateSomething(values[field]);
                    if (er !== undefined) errors[field] = er;
                } else if (field === "nombre_sector") {
                    const er = validateString50(values[field]);
                    if (er !== undefined) errors[field] = er;
                } else if (props.dialogState.advancedOptions && field === "timezone") {
                    const er = validateSomething(values[field]);
                    if (er !== undefined) errors[field] = er;
                }
            }
        }
        return errors;
    },
    enableReinitialize: true,
    handleSubmit: async (values, { props }) => {
        props.setMainDialogState({visible:false});
        const body = {
            tipo: props.dialogState.dataTipo,
            loggerName: props.dialogState.selectedLogger.name,
            sectorName: values.nombre_sector,
            nodeName: values.nombre_sector,
            from: values.last_data,
            timezone: values.timezone,
            apiKey: props.dialogState.apiKey,
            locale: props.i18n.language
        };
        props.conectar(body);
    },
})(withTranslation()(IrrimaxForm));

export { IrrimaxFormikForm };
